import { ROLE_ADMIN, ROLE_VACATION_DP, ROLE_VACATION_VIEWER } from '@/contexts/AuthContext';
import type { DpPortalAccessContext, DpPortalTab } from './dpPortal.types';

export const DP_PORTAL_BASE_PATH = '/departamento-pessoal';

export const DP_PORTAL_TITLE = 'Portal do DP';
export const DP_PORTAL_SUBTITLE = 'Férias, hora extra, Raro Invest, benefícios e outros pedidos ao DP.';

export const DP_PORTAL_ROLES = {
    management: [ROLE_ADMIN, ROLE_VACATION_DP],
    overview: [ROLE_ADMIN, ROLE_VACATION_DP, ROLE_VACATION_VIEWER],
};

export const DP_PORTAL_TABS: readonly DpPortalTab[] = [
    { id: 'solicitacoes', label: 'Solicitações ao DP', path: 'solicitacoes', access: { kind: 'everyone' } },
    { id: 'ferias', label: 'Minhas férias', path: 'ferias', access: { kind: 'vacationModule' } },
    { id: 'atendimentos', label: 'Atendimentos', path: 'atendimentos', access: { kind: 'roles', roles: DP_PORTAL_ROLES.management } },
    { id: 'aprovacoes', label: 'Aprovações', path: 'aprovacoes', access: { kind: 'manager' } },
    { id: 'gestao', label: 'Gestão de férias', path: 'gestao', access: { kind: 'roles', roles: DP_PORTAL_ROLES.management } },
    { id: 'panorama', label: 'Dashboard', path: 'dashboard', access: { kind: 'roles', roles: DP_PORTAL_ROLES.overview } },
];

function canAccessTab(tab: DpPortalTab, context: DpPortalAccessContext): boolean {
    const { access } = tab;
    if (access.kind === 'everyone') return true;
    if (access.kind === 'vacationModule') return context.canSeeModule;
    if (access.kind === 'manager') return context.isManager;
    return access.roles.some(role => context.hasRole(role));
}

export function getVisibleDpPortalTabs(
    tabs: readonly DpPortalTab[],
    context: DpPortalAccessContext
): DpPortalTab[] {
    return tabs.filter(tab => canAccessTab(tab, context));
}

export function getDpPortalTabHref(tab: DpPortalTab): string {
    return `${DP_PORTAL_BASE_PATH}/${tab.path}`;
}
